import {
  InputBase as MuiInputBase,
  InputBaseProps as MuiInputBaseProps,
  styled,
} from '@mui/material'
import { forwardRef } from 'react'

export type InputBaseProps = MuiInputBaseProps & {
  whiteLilacBackground?: boolean
}

const StyledInputBase = styled(MuiInputBase, {
  shouldForwardProp: prop => prop !== 'whiteLilacBackground',
})<InputBaseProps>(({ theme, whiteLilacBackground }) => ({
  ...(whiteLilacBackground && {
    backgroundColor: theme.palette.primary.light,
    borderColor: 'rgba(123, 123, 142, 0.2)',
  }),

  '&.MuiInputBase-multiline': {
    height: 'auto',
  },
}))

export const InputBase = forwardRef<HTMLInputElement, InputBaseProps>(
  (props, ref) => <StyledInputBase ref={ref} {...props} />,
)
